// extracted by mini-css-extract-plugin
export default {"navTitle":"logo_navTitle__SajaP"};